import { useMetadata } from '@contexts/org-metadata';
import { BrowserUtility } from '@utility/browser-utility';
import { ALL_DROPDOWN_OPTION, CommonConstant } from '@utility/constants/common';
import MarketPlaceService from '@utility/services/marketplace';
import { useEffect, useState, useMemo } from 'react';
import { useAsyncDebounce } from './debounceAsync';

type dataType = {
  key: string;
  text: string;
  currency_code: string;
  value: string;
  name: string;
  flag: string;
};

export const marketplaceRegionHook = (all = false, defaultAll = false) => {
  // @ts-expect-error - TS2339: Property 'loading' does not exist on type 'unknown'.
  const { loading: metadataLoading, regions, defaultRegionId } = useMetadata();
  const [data, setData] = useState<dataType[]>([]);
  const [error, setError] = useState('');
  const [regionId, setRegionId] = useState(null);
  const [userLoading, setUserLoading] = useState(true);

  const [filter, setFilter] = useState({});
  // @ts-expect-error - TS2339: Property 'marketplace_region_id' does not exist on type '{}'.
  const marketplaceRegion = useAsyncDebounce(filter.marketplace_region_id, 500);

  const fetchData = async () => {
    setUserLoading(true);
    try {
      const list = (regions || []).map(x => ({
        key: x.marketplace_region_id,
        text: x.region_alias,
        currency_code: x.currency_code,
        // label: x.region_alias,
        value: x.marketplace_region_id,
        name: x.name,
        flag: x.name.toLowerCase(),
      }));

      if (all) {
        list.unshift({
          ...ALL_DROPDOWN_OPTION,
          image: { src: '/images/world.svg' },
        });
      }
      setData(list);
      let tempRegion = '';
      /* No default region (a V2 account has no legacy regions at all): the first, if any. */
      if (!defaultRegionId) {
        tempRegion = list[0]?.key ?? '';
      } else if (defaultRegionId && list.find(x => x.key === defaultRegionId)) {
        tempRegion = defaultRegionId;
      } else if (list.length > 0) {
        tempRegion = list[0].key;
      }
      if (tempRegion) {
        BrowserUtility.save(
          CommonConstant.currentRegion,
          list.find(x => x.key === tempRegion)?.currency_code,
        );
      }
      if (defaultAll) {
        // @ts-expect-error - TS2345: Argument of type '-1' is not assignable to parameter of type 'SetStateAction<nul...
        setRegionId(-1);
      } else {
        // @ts-expect-error - TS2345: Argument of type 'string' is not assignable to parameter of type 'SetStateAction...
        setRegionId(tempRegion);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setUserLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [regions]);

  const regionChanged = regionId => {
    setRegionId(regionId);
    const currencyCode = data?.find(x => x.key === regionId)?.currency_code;
    if (currencyCode) {
      BrowserUtility.save(CommonConstant.currentRegion, currencyCode);
    }
  };

  useEffect(() => {
    if (marketplaceRegion) {
      regionChanged(marketplaceRegion);
    }
  }, [marketplaceRegion]);

  const loading = useMemo(
    () => userLoading || metadataLoading,
    [metadataLoading, userLoading],
  );

  const updateAllFilter = obj => {
    setFilter({ ...obj });
  };

  return {
    data,
    loading,
    error,
    regionId,
    updateAllFilter,
    filter,
    regionChanged,
  };
};

export const marketplaceRegionCountryValueHook = (all = false) => {
  /* @ts-expect-error - TS2339: Property 'loading' does not exist on type 'unknown'. */
  const { loading, regions } = useMetadata();
  const [error, setError] = useState('');
  const [data, setData] = useState([]);

  const fetchData = () => {
    try {
      setError('');
      const list = (regions || []).map(x => ({
        id: x.marketplace_region_id,
        text: x.region_alias,
        value: x.name,
        name: x.name,
        flag: x.name.toLowerCase(),
      }));

      if (all) {
        list.unshift({
          ...ALL_DROPDOWN_OPTION,
          image: { src: '/images/world.svg' },
        });
      }
      setData(list);
    } catch (error) {
      setError(error.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, [regions]);

  return { data, loading, error };
};

export const allMarketplaceRegionDropdownHook = (all = false) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = async () => {
    try {
      setError('');
      setLoading(true);
      const result = await MarketPlaceService.getMarketplaceRegions();

      const list = (result || [])
        .sort((x, y) =>
          x.connected === y.connected ? 0 : x.connected ? -1 : 1,
        )
        .map(x => ({
          id: x.marketplace_region_id,
          text: x.region_alias,
          value: x.marketplace_region_id,
          name: x.name,
          flag: x.name.toLowerCase(),
        }));

      if (all) {
        list.unshift({
          ...ALL_DROPDOWN_OPTION,
          image: { src: '/images/world.svg' },
        });
      }
      setData(list);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return { data, loading, error };
};
